export default __webpack_public_path__ + "static/media/storm-5.ff263368.png";